import moment from 'moment'
import Import from '../../../../images/Import.png'
import {CustomerReportContext} from '../../context'
import {useContext, useState} from 'react'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import {dataToCustomerTypeReportCSV} from '../../utils'

const CustomerTypeTableHeader = () => {
  const [isLoading, setIsLoading] = useState(false)
  const {customerTypeData, isCustomerTypeLoading} = useContext(CustomerReportContext)

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToCustomerTypeReportCSV(customerTypeData)
    if (data?.length) {
      SampleCSVDownload(data || [], `Coupon_Code_Customer_Type_Report_${formattedDateTime}`)
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex justify-content-between align-items-center mb-5'>
      <h2 className='mb-5 text-dark fw-bolder mb-8'>Customer Type</h2>
      <button
        className='btn btn-outline'
        onClick={handleDownLoadCSV}
        disabled={isLoading || !customerTypeData?.length || isCustomerTypeLoading}
      >
        <div className='d-flex align-items-center'>
          <img src={Import} alt='Import File' className='me-2 import-icon' />
          <div className='d-flex align-items-center'>
            {isLoading ? 'Downloading...' : 'Export CSV'}
            {isLoading && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </div>
        </div>
      </button>
    </div>
  )
}

export default CustomerTypeTableHeader
